import { useState, useEffect } from "react";
import { Layout } from "@/components/Layout";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import api from "@/lib/api";
import { Percent, Save } from "lucide-react";

const CATEGORIES = [
  { key: "fara_permis_25", label: "Fără permis 25 km/h" },
  { key: "cu_permis_50", label: "Cu permis 50cc" },
  { key: "125cc", label: "125cc" },
  { key: "mai_mare", label: "Mai mare (peste 125cc)" },
];
const QUICK = [0, 10, 15, 20, 25, 30];

function CategoryRow({ cat, value, onChange }) {
  return (
    <div data-testid={`discount-row-${cat.key}`} className="flex flex-col sm:flex-row sm:items-center gap-3 py-4 border-b border-border last:border-0">
      <p className="font-semibold sm:w-56">{cat.label}</p>
      <div className="flex flex-wrap gap-1.5">
        {QUICK.map(q => (
          <Button key={q} size="sm" variant={value === q ? "default" : "outline"} data-testid={`quick-${cat.key}-${q}`} onClick={() => onChange(q)}>
            {q === 0 ? "Fără" : `-${q}%`}
          </Button>
        ))}
      </div>
      <div className="flex items-center gap-1 sm:ml-auto">
        <Input type="number" min={0} max={90} value={value} data-testid={`input-${cat.key}`} className="w-20"
          onChange={e => onChange(Math.min(90, Math.max(0, parseInt(e.target.value || "0", 10))))} />
        <span className="text-muted-foreground">%</span>
      </div>
    </div>
  );
}

export default function CategoryDiscountsPage() {
  const [values, setValues] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/public/store/category-discounts").then(r => setValues(r.data)).catch(() => toast.error("Eroare la încărcare"));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/category-discounts", values);
      toast.success("Reducerile au fost salvate! Prețurile din magazin sunt actualizate.");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Eroare la salvare");
    }
    setSaving(false);
  };

  return (
    <Layout>
      <Card data-testid="category-discounts-page" className="max-w-3xl">
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><Percent className="w-5 h-5" />Reduceri pe categorii (Black Friday)</CardTitle>
          <p className="text-sm text-muted-foreground">Alege procentul pentru fiecare categorie. Prețul redus apare automat în magazin, cu prețul vechi tăiat.</p>
        </CardHeader>
        <CardContent>
          {CATEGORIES.map(cat => (
            <CategoryRow key={cat.key} cat={cat} value={values[cat.key] || 0} onChange={v => setValues(s => ({ ...s, [cat.key]: v }))} />
          ))}
          <Button data-testid="save-discounts-btn" onClick={save} disabled={saving} className="mt-5 w-full sm:w-auto">
            <Save className="w-4 h-4 mr-2" />{saving ? "Se salvează..." : "Salvează reducerile"}
          </Button>
        </CardContent>
      </Card>
    </Layout>
  );
}
